<template>
  <div>
    <div v-if="loading" class="loading-overlay">
      <b-spinner variant="primary" label="Loading..."></b-spinner>
      <p>Yükleniyor...</p>
    </div>
    <b-navbar toggleable="md" style="background-color: #ec1b24;" type="dark">
      <b-navbar-brand>
        <img :src="require('../assets/images/NavbarImages/logo-mamas.png')" id="logo">
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-4">
        <!-- ROLE_USER MENÜLERİ -->
          <template v-if="$store.state.userRole === 'ROLE_USER'">
            <b-nav-item :to="{ name: 'Order'}" :active="$route.name == 'Order'">Sipariş Ver</b-nav-item>
            <b-nav-item :to="{ name: 'ClientOrderList'}" :active="$route.name == 'ClientOrderList'">Sipariş Geçmişi</b-nav-item>
            <b-nav-item :to="{ name: 'TransactionHistory'}" :active="$route.name == 'TransactionHistory'">Ekstre</b-nav-item>
            <b-nav-item :to="{ name: 'ClientReceiptList'}" :active="$route.name == 'ClientReceiptList'">Dekont Geçmişi</b-nav-item>
          </template>

          <!-- ROLE_ADMIN MENÜLERİ -->
          <template v-else-if="$store.state.userRole === 'ROLE_ADMIN'">
            <b-nav-item :to="{ name: 'AdminPanel'}" :active="$route.name == 'AdminPanel'">Admin Panel</b-nav-item>
            <b-nav-item :to="{ name: 'AdminOrderList'}" :active="$route.name == 'AdminOrderList'">Siparişler</b-nav-item>
            <b-nav-item :to="{ name: 'AdminShipmentDocumentList'}" :active="$route.name == 'AdminShipmentDocumentList'">İrsaliyeler</b-nav-item>
          </template>
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto align-items-center">
          <div v-if="$store.state.userRole === 'ROLE_USER'" class="balance-wrapper d-flex align-items-center mr-3">
            <img src="../assets/images/NavbarImages/wallet.png" alt="Wallet" class="wallet-icon" />
            <span class="balance-text ml-2">{{ this.$store.state.balanceText }}</span>
          </div>

          <div v-if="$store.state.userRole === 'ROLE_USER'" class="refresh-action d-flex align-items-center mr-3" @click="refreshBalance">
            <img src="../assets/images/NavbarImages/refresh-balance.png" alt="Refresh" class="refresh-icon" />
            <span class="refresh-text ml-2">Bakiye Güncelle</span>
          </div>

          <!-- routeToBalance ile kart bilgilerini almak için banka ekranına yönlendiriyorum oradan 3d ödeme için yönlendiriyorum -->
<!--          <div v-if="$store.state.userRole === 'ROLE_USER'" class="balance-action d-flex align-items-center mr-3" @click="routeToBalance">-->
<!--            <img src="../assets/images/NavbarImages/add.png" alt="Topup" class="topup-icon" />-->
<!--            <span class="topup-text ml-2">Bakiye Yükle</span>-->
<!--          </div>-->

          <!-- routeToBalanceWithCard ile önce kart bilgilerini bizim sitede alıp sonra bankaya 3d ödeme için yönlendiriyorum -->
          <div v-if="$store.state.userRole === 'ROLE_USER'" class="balance-action d-flex align-items-center mr-3" @click="routeToBalanceWithCard">
            <img src="../assets/images/NavbarImages/add.png" alt="Topup" class="topup-icon" />
            <span class="topup-text ml-2">Bakiye Yükle</span>
          </div>

          <div v-if="$store.state.username" class="logout-action d-flex align-items-center" @click="logout">
            <img src="../assets/images/NavbarImages/logout.png" alt="Logout" class="logout-icon" />
            <span class="logout-text ml-2">Çıkış Yap</span>
          </div>
        </b-navbar-nav>

      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import ClientService from "@/service/ClientService";
export default {
  name: "nav-bar",
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async redirectLogin() {
      if (this.$route.name !== 'Login') {
        await this.$router.push({ name: 'Login' });
      }
    },
    async logout() {
      localStorage.removeItem("user");
      this.$store.commit('logout');
      await this.redirectLogin();
    },
    async routeToBalance() {
      if (this.$route.name !== 'Balance') {
        await this.$router.push({ name: 'Balance' });
      }
    },
    async routeToBalanceWithCard() {
      if (this.$route.name !== 'BalanceWithCard') {
        await this.$router.push({ name: 'BalanceWithCard' });
      }
    },
    async refreshBalance() {
      try {
        this.loading = true;
        const data = {
          clientId: this.$store.state.clientId,
        };
        const response = await ClientService.refreshBalance(data);
        this.$store.commit('setBalanceText', response);
      } catch (error) {
        console.error("Bakiye güncellenirken hata oluştu:", error);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
#logo {
  width: 90px;
  height: 92px;
  margin-top: -3px;
}
.navbar-dark .navbar-nav .nav-link {
  color: white !important;
}
::v-deep .dropdown .nav-link {
  color: white !important;
}
.balance-wrapper {
  background-color: #fff;
  border-radius: 8px;
  padding: 6px 12px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
}

.wallet-icon {
  width: 20px;
  height: 20px;
}

.balance-text {
  font-weight: 600;
  font-size: 14px;
  color: #333;
}

.balance-action {
  background-color: #fff;
  border-radius: 8px;
  padding: 6px 12px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: background-color 0.2s;
}

.balance-action:hover {
  background-color: #f5f5f5;
}

.topup-icon {
  width: 20px;
  height: 20px;
}

.topup-text {
  font-weight: 600;
  font-size: 14px;
  color: #333;
}
.logout-action {
  background-color: #fff;
  border-radius: 8px;
  padding: 6px 12px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: background-color 0.2s;
  margin-right: 1rem;
}

.logout-action:hover {
  background-color: #f5f5f5;
}

.logout-icon {
  width: 20px;
  height: 20px;
}

.logout-text {
  font-weight: 600;
  font-size: 14px;
  color: #333;
}

.refresh-action {
  background-color: #fff;
  border-radius: 8px;
  padding: 6px 12px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: background-color 0.2s;
  height: 36px;
}

.refresh-action:hover {
  background-color: #f5f5f5;
}

.refresh-icon {
  width: 20px;
  height: 20px;
}

.refresh-text {
  font-weight: 600;
  font-size: 14px;
  color: #333;
}

</style>
